<!--
 * @Description: 综合考核评分
 * @Author: maqinghe 
 * @Date: 2023年06月09日 13:04:22
-->
<template>
  <div class='content-page atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item label="姓名">
            <selecter v-model="searchParam.wkNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
          <el-form-item class="multi-line">
            <el-button type="downloadTemplate" style="width: 110px!important;" @click="exportTask">综合考核表导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-tabs" v-if="false">
        <div
          class="table-tab"
          v-for="tab in tabs"
          :class="{'table-tab--active': currentTab === tab.value}"
          @click="switchTab(tab.value)"
        >
          {{ tab.name }}
        </div>
      </div>
      <div class='table-content' v-show="currentTab === 0">
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table"
          @cell-dblclick="goDetail"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="300"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="150">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{row}">
              <template v-if="row.category === 'Month'">
                <el-tag v-if="row.status === 0 || row.status === 20 || row.status === 30 || row.status === 40 || row.status === 50" type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-if="row.status === 10" type="close" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
              <template v-else-if="row.category === 'Year'">
                <el-tag type="complete" effect="dark">
                  {{ yearStatusMap[row.status] || '' }}
                </el-tag>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="50">
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='toPage(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <!-- 年计划考核 -->
      <div class='table-content' v-show="currentTab === 1">
        <div class="collapse" @click="yearCollapse($refs.table1)" :style="{'right': yearCollapseRight}">
          <i :class="[isYearCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table1"
          @cell-dblclick="goDetail"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="300"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="150">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{row}">
              <el-tag type="complete" effect="dark">
                {{ yearStatusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="50">
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='toPage(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify0" width="110" title="重要KPI成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify0}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify10" width="100" title="业务成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify10}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify20" width="110" title="费效管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify20}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify30" width="150" title="人力资源管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify30}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify40" width="150" title="企业文化管理成绩" :visible="isShowYearPlan" fixed="right">
            <template #default="{row}">
              <div>{{row.classify40}}</div>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>

      <!-- 员工绩效参考 -->
      <div class='table-content' v-show="currentTab === 2">
        <div class="collapse" @click="personCollapse($refs.table2)" :style="{'right': personCollapseRight}">
          <i :class="[isPersonCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="table2"
          @cell-dblclick="goDetail"
        >
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="300"></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="150">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="category" title="类型" width="150">
            <template #default="{row}">
              <span v-if="row.category==='Year'">年计划考核</span>
              <span v-if="row.category==='Month'">员工绩效考核</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" min-width="95">
            <template #default="{row}">
              <el-tag v-if="row.status === 0 || row.status === 20 || row.status === 30 || row.status === 40 || row.status === 50" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-if="row.status === 10" type="close" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="50">
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='toPage(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
          <!-- 折叠分数 -->
          <vxe-table-column field="classify100" width="80" title="绩效成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify100}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify110" width="80" title="企业文化导向成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify110}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify120" width="80" title="个人成长成绩" :edit-render="{autofocus: '.el-input__inner'}" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify120}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="classify130" width="80" title="OEC综合成绩" :visible="isShowPerson" fixed="right">
            <template #default="{row}">
              <div>{{row.classify130}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-for="col in monthColumns"
            :field="col.field"
            :width="col.width"
            :title="col.title"
            :fixed="col.fixed"
            :visible="isShowPerson"
            :key="col.field"
            class-name='col-small'
            header-class-name='col-small'
          >
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          v-show="currentTab === 0"
          background
          :current-page.sync="page.pageIndex"
          :page-size.sync="page.pageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 1"
          background
          :current-page.sync="yearPage.pageIndex"
          :page-size.sync="yearPage.pageSize"
          :total="yearTotal"
          height="100%"
          @page-change="yearPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
        <vxe-pager
          v-show="currentTab === 2"
          background
          :current-page.sync="personPage.pageIndex"
          :page-size.sync="personPage.pageSize"
          :total="personTotal"
          height="100%"
          @page-change="personPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>

    
  </div>
</template>
<script>
  import _ from 'lodash';
  import {
    CLASSIFY_MAP,
    EDITDABLE_CLASSIFY,
    WORK_SCORE,
    PERIODS,
    PERIOD_LIST,
    OEC_LEVEL,
    YEAR_PLAN_STATUS
  } from '@/utils/period-enum.js';
  import workscoreMixin from '@/mixins/workscore.mixin.js';

  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
    },
    mixins: [ workscoreMixin ],
    name: "resultSearch",
    inject: ['reload'],
    data() {
      return {
        tabs: [
          { name: '全部', value: 0, key: 'all', category: '' },
          { name: '年计划考核', value: 1, key: 'year', category: 'Year' },
          { name: '员工绩效考核', value: 2, key: 'person', category: 'Month' },
        ],
        currentTab: 0,
        isYearCollapse: true,
        isPersonCollapse: true,
        yearCollapseRight: 0,
        personCollapseRight: 0,

        classifyMap: CLASSIFY_MAP,
        editableClassify: EDITDABLE_CLASSIFY,
        statusMap: WORK_SCORE,
        yearStatusMap: YEAR_PLAN_STATUS,
        
        periods: PERIODS,
        periodList: PERIOD_LIST,

        oecLevel: OEC_LEVEL,
        categoryList: [
          {label: '年计划考核', value: 'Year' },
          {label: '员工绩效考核', value: 'Month' },
        ],

        searchParam: {
          wkNo: '',
        },
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],

        yearPage: {
          pageIndex: 1,
          pageSize: 10
        },
        yearTotal: 0,

        personPage: {
          pageIndex: 1,
          pageSize: 10
        },
        personTotal: 0,

        warnNum: 'warn-num',
        nomalNum: 'num',

        currWkNo: '',
        wkNo: '',
        msgId: '',
        role: 1,
        status: '',

        isShowYearPlan: false,
        isShowPerson: false,
        monthColumns: [
          {field: 'm1', title: '1月',  width: 35, fixed: 'right'},
          {field: 'm2', title: '2月',  width: 35, fixed: 'right'},
          {field: 'm3', title: '3月',  width: 35, fixed: 'right'},
          {field: 'm4', title: '4月',  width: 35, fixed: 'right'},
          {field: 'm5', title: '5月',  width: 35, fixed: 'right'},
          {field: 'm6', title: '6月',  width: 35, fixed: 'right'},
          {field: 'm7', title: '7月',  width: 35, fixed: 'right'},
          {field: 'm8', title: '8月',  width: 35, fixed: 'right'},
          {field: 'm9', title: '9月',  width: 35, fixed: 'right'},
          {field: 'm10', title: '10月',  width: 40, fixed: 'right'},
          {field: 'm11', title: '11月',  width: 40, fixed: 'right'},
          {field: 'm12', title: '12月',  width: 40, fixed: 'right'},
        ],

        classifyPrefix: 'classify',

        isDynamicEffective: true, // 是否启用动态版本
      }
    },
    created() {
      this.wkNo = this.$route.query.wkNo || '';
      this.msgId = this.$route.query.msgId || '';
      this.role = this.$route.query.role || 1;
      this.date = this.$route.query.date || '';
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      this.getList();
      this.getDynamicClassify({});
    },
    methods: {
      switchTab(tabIndex) {
        this.currentTab = tabIndex;
        this.getList();
      },
      yearCollapse(el) {
        this.isYearCollapse = !this.isYearCollapse;
        if (this.isYearCollapse) {
          this.hideYearPlan();
        } else {
          this.showYearPlan();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setYearPosition();
        });
      },
      showYearPlan() {
        this.isShowYearPlan = true;
      },
      hideYearPlan() {
        this.isShowYearPlan = false;
      },
      setYearPosition() {
        setTimeout(() => {
          if (this.isYearCollapse) {
            this.yearCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table1.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.yearCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      personCollapse(el) {
        this.isPersonCollapse = !this.isPersonCollapse;
        if (this.isPersonCollapse) {
          this.hidePerson();
        } else {
          this.showPerson();
        }
        el && el.refreshColumn().then(() => {
          return el.refreshColumn();
        }).then(() => {
          this.setPersonPosition();
        });
      },
      showPerson() {
        this.isShowPerson = true;
      },
      hidePerson() {
        this.isShowPerson = false;
      },
      setPersonPosition() {
        setTimeout(() => {
          if (this.isPersonCollapse) {
            this.personCollapseRight = '0';
          } else {
            let fixedWidth = this.$refs.table2.$el.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
            this.personCollapseRight = fixedWidth + 'px';
          }
        }, 10);
      },

      async getList(resetPage) {
        if (resetPage) {
          this.page.pageIndex = 1;
        }
        if (this.wkNo) {
          this.currWkNo = this.wkNo;
        }
        let page = this.page;
        switch (this.currentTab) {
          case 0:
            page = this.page;
            break;
          case 1:
            page = this.yearPage;
            break;
          case 2:
            page = this.personPage;
            break;
          default:
            break;
        }
        let param = Object.assign({loginWkNo: this.currWkNo }, this.searchParam, page);
        await this.$ajax.post(this.$api.period.workScore.scoreList, param).then(async (res) => {
          let resList = res.data.rows || [];
          resList = resList.map(p => {
            p.parentId = null;
            p.hasChild = p.isOrLeader ? true : false;
            return p;
          });
          let tableDatas = [];
          resList.forEach(item => {
            let rowData = {
              ...item.periodResultInfo,
              ...item,
            };
            let monthData = item.oecResultInfo || [];

            for (let i = 0; i < this.monthColumns.length; i++) {
              rowData[this.monthColumns[i]] = '';
            }
            monthData.forEach(p => {
              rowData['m' + p.month] = p.ratingResult || '';
            });

            let classifyData = item.periodClassifyScoreInfo || [];
            for (const key in this.classifyMap) {
              rowData[this.classifyPrefix + key] = '';
            }
            classifyData.forEach(c => {
              rowData[this.classifyPrefix + c.workClassify] = c.score;
            });

            tableDatas.push(rowData);
          });
          this.tableData = tableDatas;
          
          switch (this.currentTab) {
            case 0:
              this.total = res.data.total;
              break;
            case 1:
              this.yearTotal = res.data.total;
              break;
            case 2:
              this.personTotal = res.data.total;
              break;
            default:
              break;
          }
        });
      },


      pageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      yearPageChange({currentPage}) {
        this.yearPage.pageIndex = currentPage;
        this.getList();
      },
      personPageChange({currentPage}) {
        this.personPage.pageIndex = currentPage;
        this.getList();
      },


      toPage(row) {
        if (row.category === 'Month') {
          this.$router.push({path: '/personal/workscore/detail', query: { id: row.id, editStatus: 'approve' }});
        } else if (row.category === 'Year') {
          let pagePath = '/personal/workscore/yearDetail';
          if (this.isDynamicEffective && row.versionId) {
            pagePath = '/personal/workscore/yearDetailNext';
          }
          this.$router.push({path: pagePath, query: { id: row.id, editStatus: 'approve' }});
        }
      },
      goDetail({row}) {
        this.toPage(row);
      },

      // 导出
      exportExcel() {
        const params = {
          LoginWkNo: this.currWkNo,
          WkNo: this.searchParam.wkNo,
        };
        this.$ajax.post(this.$api.period.workScore.scoreListExport, params, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = '综合考核评分'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      exportTask() {
        const params = {
          LoginWkNo: this.currWkNo,
          WkNo: this.searchParam.wkNo,
        };
        this.$ajax
          .get(this.$api.period.workScore.taskExport, params)
          .then((res) => {
            if (res.code === 0) {
              this.$router.push({
                path: '/manage/export-task/index',
              });
            }
          })
          .catch(() => {});
      },
    },
    watch: {
      $route(){
        this.reload();
      },
    }
  }
</script>
<style scoped lang='scss'>
  .content-page {
    height: 100%;
    .table-content {
      position: relative;
    }
    .atb-content-bg {
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
  }
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
  .collapse {
    margin-top: -15px;
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: rgba(#000, 0.1);
    z-index: 99;
    cursor: pointer;
    &:hover {
      background-color: rgba(#000, 0.2);
    }
    i {
      font-size: 14px;
      color: #fff;
    }
  }
  .table-tabs {
    .table-tab {
      display: inline-block;
      margin: 8px;
      padding: 8px 10px;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid $--color-primary;
      background-color: #d8f5f1;
      color: $--color-primary;
      &:hover, &.table-tab--active {
        background-color: $--color-primary;
        color: #fff;
      }
    }
    
  }
</style>